import { Component, Input } from '@angular/core';
import { ShipmentCardDto } from '@shared/src/dtos/shipment/ShipmentCardDto';
import { PhaseCardDto } from '@shared/src/dtos/phase/PhaseCardDto';
import { ShipmentDeliveryDto } from '@shared/src/dtos/shipment/delivery/ShipmentDeliveryDto';
import { ShipmentDeliveryController } from '@shared/src/controllers/route/delivery/shipmentdelivery.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { fadeInOut } from '@shared/src/animations';

@Component({
    selector: 'shared-shipment-header',
    templateUrl: './shared.shipment.header.component.html',
    styleUrls: ['./shared.shipment.header.component.scss'],
    animations: [fadeInOut]
})
export class SharedShipmentHeaderComponent {

    constructor(public shipmentDeliveryController: ShipmentDeliveryController) { }

    @Input() public phase: PhaseCardDto;

    private _shipment: ShipmentCardDto;
    public delivery: ShipmentDeliveryDto;
    public showStats = false;

    @Input()
    set shipment(value: ShipmentCardDto) {
        if (this._shipment === value)
            return;
        this._shipment = value;
        this.loadDelivery();
    }
    get shipment(): ShipmentCardDto {
        return this._shipment;
    }

    private loadDelivery() {
        if (this.shipment == null || HLong.isNullOrNullLong(this.shipment.shipmentId)) {
            this.delivery = null;
            return;
        }
        this.shipmentDeliveryController.getShipmentDelivery(this.shipment.shipmentId, false).subscribe(data => {
            this.delivery = data;
        });
    }

    toggleView() {
        this.showStats = !this.showStats;
    }
}
